<form
  [signalForm]="configForm"
  class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4"
>
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label" />
    <lib-signal-text-field
      label="Help text"
      placeholder="Shown under the field"
      [formField]="configForm.helpText" />

    <div class="flex flex-col gap-2">
      <lib-signal-radio-group
        label="Rating scale"
        hint="Choose how many points respondents can select."
        groupName="rating-scale"
        size="sm"
        orientation="vertical"
        [options]="scaleOptions"
        [value]="model().max"
        (valueChange)="onScaleChange($event)" />
    </div>
  </section>

  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Validators
    </h3>
    <lib-signal-checkbox
      label="Required"
      [formField]="configForm.required" />
  </section>
</form>
